import { api } from '../api/endpoints';
import { configureAnalytics } from './analytics';

let started = false;

/**
 * Holt die Mess-ID vom Server (`GET /version`) und schaltet die Einwilligungsverwaltung ein. Ohne Mess-ID bleibt alles
 * aus. Ist der Server beim Start nicht erreichbar (offline gestartete PWA), wird beim nächsten `online` erneut versucht.
 */
export async function initAnalytics(): Promise<void> {
  if (started) return;
  started = true;
  try {
    const { analytics } = await api.version();
    configureAnalytics(analytics?.gaMeasurementId ?? null);
  } catch {
    started = false;
    window.addEventListener('online', () => void initAnalytics(), { once: true });
  }
}
